import React from 'react';
import './Projects.css';
import { FaCode, FaTools, FaRobot, FaCogs } from 'react-icons/fa';

const Projects = () => {
  return (
    <div className="projects-container">
      <div className="projects-content">
        <h1>Our Projects</h1>
        
        <div className="stay-tuned-section">
          <div className="stay-tuned-content">
            <h2>Stay Tuned</h2>
            <p>We're working on something amazing! Our portfolio of projects will be available soon.</p>
            
            <div className="project-icons">
              <div className="project-icon">
                <FaCode />
                <span>Custom Solutions</span>
              </div>
              <div className="project-icon">
                <FaTools />
                <span>Engineering</span>
              </div>
              <div className="project-icon">
                <FaRobot />
                <span>Automation</span>
              </div>
              <div className="project-icon">
                <FaCogs />
                <span>Integration</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects; 